declare namespace $ {

	export class $shm_hitalama_dragtree_drag extends $rise_drag {
		hold_delay( ): number
		hold_move_threshold( ): number
	}
	
}

//# sourceMappingURL=drag.view.tree.d.ts.map